import { getStaticImageUrl } from 'client/utils/image-helpers';

export const CANVAS_CREATIVE_ID = 'chat-canvas';
export const DEFAULT_IFRAME_URL = '/';

export const ERROR_CREATIVE_ID = {
  SUGGESTED: 'chat-canvas-suggested',
};

export const CANVAS_ICONS = {
  DOCK_RIGHT: getStaticImageUrl('/img/chat-canvas/icon-dock-right.svg'),
  EDIT_SQUARE: getStaticImageUrl('/img/chat-canvas/icon-edit-square.svg'),
  EDIT_SQUARE_WHITE: getStaticImageUrl('/img/chat-canvas/icon-edit-square-white.svg'),
  COPY: getStaticImageUrl('/img/chat-canvas/icon-copy.svg'),
  THUMB_UP: getStaticImageUrl('/img/chat-canvas/icon-thumb-up.svg'),
  THUMB_UP_SOLID: getStaticImageUrl('/img/chat-canvas/icon-thumb-up-solid.svg'),
  THUMB_DOWN: getStaticImageUrl('/img/chat-canvas/icon-thumb-down.svg'),
  THUMB_DOWN_SOLID: getStaticImageUrl('/img/chat-canvas/icon-thumb-down-solid.svg'),
  DOTS: getStaticImageUrl('/img/chat-canvas/icon-dots.svg'),
  CHECK: getStaticImageUrl('/img/chat-canvas/icon-check.svg'),
  NOTE: getStaticImageUrl('/img/chat-canvas/icon-note.svg'),
  CLICK: getStaticImageUrl('/img/chat-canvas/icon-click.svg'),
  SHARE: getStaticImageUrl('/img/chat-canvas/icon-ios-share.svg'),
  SHARE_WHITE: getStaticImageUrl('/img/chat-canvas/icon-ios-share-white.svg'),
  MIC: getStaticImageUrl('/img/chat-canvas/icon-mic.svg'),
  RED_SPARKLE: getStaticImageUrl('/img/chat-canvas/red-sparkle.svg'),
};

export const PREDEFINED_MESSAGE = {
  WELCOME: 'STARTCHAT',
  SUGGESTION: 'Generate suggestions',
};

export const RESPONSE_ERROR = {
  CANT_ASSIST:
    'Sorry, that’s not something I can assist with. I’m here if you’d like guidance on car searches or research.',
  SOMETHING_WRONG: 'Sorry, something went wrong. Please try again later.',
};

export const SELECTION_TYPE = {
  SUGGESTED_MESSAGE: 'suggested_message',
  STARTER_MESSAGE: 'starter_message',
};

export const ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
  EMPTY_STATE: 'empty_state',
  NO_ROLE: 'no_role',
};

export const STREAM_STATE = {
  NO_STREAM: 'no_stream',
  STREAMING: 'streaming',
};

export const PLACEHOLDER_IMAGE_SRC = 'placeholder';

export const USER_TEXT_TRACKING_LENGTH = 800;
export const LOADING_TIMEOUT = 10000;

export const EMPTY_STATE_MESSAGE_STREAM = {
  default: [
    '## Need',
    ' help with',
    ' your car',
    ' search?',
    " I'm",
    ' here.',
    '\n\n',
    'You can',
    ' ask me',
    ' anything',
    ' about this',
    ' car or',
    ' any other',
    ' car you',
    ' are interested',
    ' in.',
  ],
};
